var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "facebook_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16 32C7.164 32 0 24.836 0 16 0 7.163 7.164 0 16 0c8.837 0 16 7.163 16 16 0 8.836-7.163 16-16 16",
  fill: "#FFF",
  mask: "url(#facebook_svg__a)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.562 25.671h3.895v-9.753h2.718l.289-3.266h-3.007v-1.86c0-.77.154-1.074.9-1.074h2.107v-3.39h-2.697c-2.898 0-4.205 1.278-4.205 3.72v2.604h-2.026v3.307h2.026v9.712Z",
  fill: "#231F20"
}))));
export default SvgFacebook;